export interface IFollowUpDonor {
    id: number,
    centerId: number,
    mrn: string,
    firstName: string,
    lastName: string,
    email: string,
    surveyInstanceSkip: number,
    phone: string,
    country: number,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    postalCode: string,
    birthDate: string,
    donationDate: string,
    gender: number,
    heightInches: number,
    heightSubFeet: number,
    heightSubInches: number,
    weightLbs: number,
    coordinatorContactId: number
}